export const ARGENTINA_DNI = 'argentina_dni';
export const ARGENTINA_CUIL = 'argentina_cuil';
export function argentinaDNI(value = '') {
    const pattern = '^[0-9]{7,8}$';
    const isValid = !value ? true : !!value.match(pattern);
    return [{
            message: isValid ? '' : 'patient.message.invalid-value',
            name: ARGENTINA_DNI,
            valid: isValid,
        }];
}
export function argentinaCUIL(value = '') {
    const pattern = '^[0-9]{11}$';
    const isValid = !value ? true : !!value.match(pattern);
    return [{
            message: isValid ? '' : 'patient.message.invalid-value',
            name: ARGENTINA_CUIL,
            valid: isValid,
        }];
}
//# sourceMappingURL=argentina-validators.js.map